// extracted by mini-css-extract-plugin
export var active = "_87-1";
export var activeSubdued = "_87-2";
export var compact = "_87-3";
export var fill = "_87-6";
export var pulse = "_87-4";
export var settingHighlightPulse = "_87-5";
export var wrapper = "_87-0";